import React from "react";
import TableNFePaymentTotals from "./components/TableNFePaymentTotals";
import AddPayment from "./components/AddPayment";
import PaymentsTable from "./components/PaymentsTable";

import { PaymentContext } from "./context";
import { CreateNFeContext } from "../../Context";

export default () => {
  const createNFeContext = React.useContext(CreateNFeContext);
  const [disabled, setDisabled] = React.useState(false);

  function onChangePayment() {
    const { total_paid, total_nfe, other_expenses } = createNFeContext.nfe;
    const { discount_value } = createNFeContext.nfe.identification;
    const payed = total_paid >= (total_nfe + other_expenses || 0 ) - (discount_value || 0);
    setDisabled(payed);
  }
  React.useEffect(onChangePayment, [
    createNFeContext.nfe.payments,
    createNFeContext.nfe.total_paid,
    createNFeContext.nfe.identification.discount_value,
  ]);
  return (
    <PaymentContext.Provider value={{ disabled, setDisabled }}>
      <TableNFePaymentTotals />
      <AddPayment />
      <PaymentsTable />
    </PaymentContext.Provider>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/NFePaymentShipping/Payments/index.jsx